module.exports = __webpack_public_path__ + "assets/green_check_line-eb7ff9.svg";